// offset to consider a widget as full size (doesn't have to be exact)
export const FULL_SIZE_OFFSET = 4;
export const MIN_SCREEN_WIDTH = 360;
// only responsive layout if screen width smaller than this
export const MIN_RESPONSIVE_LAYOUT_SCREEN_WIDTH = 1000;
